import { createContext } from 'react';

export const LoginWizardDescriptionContext = createContext<((description: string | null) => void) | null>(null);
LoginWizardDescriptionContext.displayName = 'LoginWizardDescriptionContext';
